import React from "react";

const CalendarLegend = () => {
    const legendItems = [
        { color: "#8bc34a", text: "Equal or more 95%" },
        { color: "#ffcc00", text: "More than 50%" },
        { color: "#f44336", text: "Less than 50%" },
        { color: "#9e9e9e", text: "No Data" },
    ];

    return (
        <div style={{ display: "flex", gap: "20px", alignItems: "center", marginBottom: "16px" }}>
            {legendItems.map((item, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                    }}
                >
                    <div
                        style={{
                            width: "20px",
                            height: "20px",
                            backgroundColor: item.color,
                            borderRadius: "3px",
                        }}
                    ></div>
                    <span style={{ fontSize: "14px", color: "#37474f" }}>
            {item.text}
          </span>
                </div>
            ))}
        </div>
    );
};

export default CalendarLegend;
